import {
  Box,
  Card,
  Flex,
  Grid,
  SimpleGrid,
  Skeleton,
  SkeletonCircle,
} from "@chakra-ui/react";

const skeletonProps = {
  bg: "#DAE9FF",
  borderRadius: "md",
};

const cardProps = {
  bg: "white",
  border: "none",
  borderWidth: 0,
  boxShadow: "sm",
  borderRadius: "2xl",
};

const StatSkeleton = () => (
  <Card.Root {...cardProps}>
    <Card.Body>
      <Flex justify="space-between" align="center">
        <Box flex="1">
          <Skeleton
            {...skeletonProps}
            height="12px"
            width="120px"
            mb={3}
          />

          <Skeleton
            {...skeletonProps}
            height="30px"
            width="90px"
            mb={3}
          />

          <Skeleton
            {...skeletonProps}
            height="10px"
            width="150px"
          />
        </Box>

        <SkeletonCircle
          bg="#DAE9FF"
          size="12"
        />
      </Flex>
    </Card.Body>
  </Card.Root>
);

const MiniSkeleton = () => (
  <Card.Root {...cardProps}>
    <Card.Body>
      <Skeleton
        {...skeletonProps}
        height="10px"
        mb={3}
      />

      <Skeleton
        {...skeletonProps}
        height="28px"
        width="45px"
      />
    </Card.Body>
  </Card.Root>
);

const PanelSkeleton = ({
  height = "300px",
}) => (
  <Card.Root {...cardProps}>
    <Card.Body>
      <Skeleton
        {...skeletonProps}
        height="18px"
        width="180px"
        mb={6}
      />

      <Skeleton
        {...skeletonProps}
        height={height}
      />
    </Card.Body>
  </Card.Root>
);

export default function DashboardSkeleton() {
  return (
    <>
      {/* Header */}
      <Box mb={8}>
        <Skeleton
          {...skeletonProps}
          height="36px"
          width="320px"
          mb={3}
        />

        <Skeleton
          {...skeletonProps}
          height="15px"
          width="260px"
        />
      </Box>

      {/* Top Section */}
      <Grid
        templateColumns={{
          base: "1fr",
          xl: "2fr 320px",
        }}
        gap={6}
      >
        <Box>
          <SimpleGrid
            columns={{
              base: 1,
              md: 3,
            }}
            gap={6}
          >
            {Array.from({ length: 6 }).map((_, i) => (
              <StatSkeleton key={i} />
            ))}
          </SimpleGrid>

          <Skeleton
            {...skeletonProps}
            height="14px"
            width="240px"
            mt={8}
            mb={4}
          />

          <SimpleGrid
            columns={{
              base: 2,
              lg: 6,
            }}
            gap={3}
          >
            {Array.from({ length: 6 }).map((_, i) => (
              <MiniSkeleton key={i} />
            ))}
          </SimpleGrid>
        </Box>

        <PanelSkeleton height="420px" />
      </Grid>

      {/* Middle Section */}
      <Grid
        mt={8}
        gap={6}
        templateColumns={{
          base: "1fr",
          xl: "2fr 320px",
        }}
      >
        <PanelSkeleton height="330px" />

        <Flex
          direction="column"
          gap={6}
        >
          <PanelSkeleton height="140px" />
          <PanelSkeleton height="170px" />
        </Flex>
      </Grid>

      {/* Bottom Section */}
      <Grid
        mt={8}
        gap={6}
        templateColumns={{
          base: "1fr",
          xl: "2fr 370px",
        }}
      >
        <PanelSkeleton height="360px" />
        <PanelSkeleton height="360px" />
      </Grid>
    </>
  );
}